// The label drawn over a trail-camera photo in the full-screen viewer, in the
// mobile app's format so the same photo reads the same on both:
//
//   WEHUNT | 25/08/2026 05:17:11 | DK1 SVINNINGE
//
// The date is deliberately NOT locale-formatted. Every other date on the web is,
// but this one has to match what the phone stamps on the same photo — the whole
// point of the label — and the app renders a fixed dd/MM/yyyy HH:mm:ss for every
// language. Formatting it per locale here would put a differently-written date
// on the two screens a hunter is comparing.

const APP_NAME = 'WEHUNT'

const pad2 = (value: number) => String(value).padStart(2, '0')

/**
 * @param takenAt ISO 8601 instant the camera captured the media.
 * @param cameraName The camera's display name, absent when it has none.
 */
export function formatPhotoStamp(takenAt: string, cameraName?: string | null): string {
  const parts = [APP_NAME]

  const taken = new Date(takenAt)
  // An unparseable instant yields NaN from every getter, and "NaN/NaN/NaN
  // NaN:NaN:NaN" stamped across the photo is worse than no date at all.
  if (!Number.isNaN(taken.getTime())) {
    parts.push(
      `${pad2(taken.getDate())}/${pad2(taken.getMonth() + 1)}/${taken.getFullYear()} ` +
        `${pad2(taken.getHours())}:${pad2(taken.getMinutes())}:${pad2(taken.getSeconds())}`,
    )
  }

  if (cameraName && cameraName.trim() !== '') parts.push(cameraName.toUpperCase())

  return parts.join(' | ')
}
